import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Marquee } from "@/components/landing/Marquee";
import { Disclosure } from "@/components/landing/Disclosure";
import { BossHero } from "@/components/boss/BossHero";
import { MyStory } from "@/components/boss/MyStory";
import { Lost } from "@/components/boss/Lost";
import { BossSuite } from "@/components/boss/BossSuite";
import { RealResults } from "@/components/boss/RealResults";
import { Faq } from "@/components/boss/Faq";
import { FinalCta } from "@/components/boss/FinalCta";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -60 } });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="grain" data-testid="landing-page">
      <Marquee />
      <main>
        <BossHero />
        <MyStory />
        <Lost />
        <BossSuite />
        <RealResults />
        <Faq />
        <FinalCta />
      </main>
      <Disclosure />
    </div>
  );
}
